import React, { createContext, useContext, useState, ReactNode } from 'react'
import { ToastData } from '../components/common/Toast'

interface ToastContextType {
  toasts: ToastData[]
  addToast: (toast: Omit<ToastData, 'id'>) => void
  removeToast: (id: string) => void
  showSuccessToast: (title: string, message: string, icon?: ReactNode) => void
  showErrorToast: (title: string, message: string, icon?: ReactNode) => void
  showAlertToast: (title: string, message: string, icon?: ReactNode) => void
}

const ToastContext = createContext<ToastContextType | undefined>(undefined)

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastData[]>([])

  const addToast = (toast: Omit<ToastData, 'id'>) => {
    const id = Math.random().toString(36).substring(2, 9)
    const newToast: ToastData = { ...toast, id }
    setToasts(prev => [...prev, newToast])
  }

  const removeToast = (id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id))
  }

  const showSuccessToast = (title: string, message: string, icon?: ReactNode) => {
    addToast({
      title,
      message,
      type: 'success',
      duration: 5000,
      icon
    })
  }

  const showErrorToast = (title: string, message: string, icon?: ReactNode) => {
    addToast({
      title,
      message,
      type: 'error',
      duration: 5000,
      icon
    })
  }
const showAlertToast = (title: string, message: string, icon?: ReactNode) => {
    addToast({
      title,
      message,
      type: 'alert',
      duration: 5000,
      icon
    })
  }
  return (
    <ToastContext.Provider value={{
      toasts,
      addToast,
      removeToast,
      showSuccessToast,
      showErrorToast,
      showAlertToast
    }}>
      {children}
    </ToastContext.Provider>
  )
}

export function useToast() {
  const context = useContext(ToastContext)
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}